var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBecomeClientIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3739",
    "data-name": "Rectangle 3739",
    width: 20,
    height: 20,
    transform: "translate(62 8)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_591",
    "data-name": "Mask Group 591",
    transform: "translate(-62 -8)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4857",
    "data-name": "Group 4857",
    transform: "translate(-1037.883 55.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M0,5.9V4.026A4.318,4.318,0,0,1,1.248.789,3.441,3.441,0,0,1,3.589,0,3.43,3.43,0,0,1,5.927.789,4.328,4.328,0,0,1,7.174,4.019V5.9A4.187,4.187,0,0,1,5.992,9.2a3.519,3.519,0,0,1-2.4.8C2.249,9.995,0,9.462,0,5.9ZM1.622,4.071V5.9c0,2.178.994,2.472,1.968,2.472S5.555,8.078,5.555,5.9V4.071C5.47,1.919,4.56,1.622,3.589,1.622S1.7,1.919,1.622,4.071Z",
    transform: "translate(1106.296 -47.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M.6,8.956a.81.81,0,0,1-.434-.7V8.234C.132,7.524,0,5.157,0,4.482a3.719,3.719,0,0,1,1.929-3.4A10.812,10.812,0,0,1,7.319,0a10.7,10.7,0,0,1,5.36,1.084,3.724,3.724,0,0,1,1.917,3.4c0,.6-.114,2.573-.182,3.694l0,.085a.813.813,0,0,1-.809.763h-.051a.812.812,0,0,1-.759-.857c0-.023,0-.075.014-.239.042-.707.17-2.857.17-3.445a2.233,2.233,0,0,0-1.3-2.1,9.635,9.635,0,0,0-4.36-.754,9.764,9.764,0,0,0-4.393.753,2.232,2.232,0,0,0-1.3,2.1c0,.414.06,1.734.166,3.619v.054a.811.811,0,0,1-1.185.8Z",
    transform: "translate(1102.585 -36.926)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecomeClientIcon);
export default __webpack_public_path__ + "static/media/become-client-icon.7f25009525ae9c8e510ed7830e0a11a3.svg";
export { ForwardRef as ReactComponent };